import Vue from 'vue';
import { Module } from 'vuex';
import { RootState } from '@/types/store';
import { objectToFormData } from 'object-to-formdata';
import { Toast } from 'vant';

export interface FrameworkState {
    pageData: {
        [page: string]: any;
    };
    notice: string[];
}

const m: Module<FrameworkState, RootState> = {
    namespaced: true,
    state: {
        pageData: {},
        notice: [],
    },
    mutations: {
        setPageData(state, { page, data }) {
            Vue.set(state.pageData, page, data);
        },
        /**
         * 记录系统通知
         */
        setNotice(state, notice) {
            state.notice = notice;
        },
    },
    actions: {
        /**
         * 用于获取系统通知
         */
        async getNotice(context) {
            const response = await Vue.axios.get('/api/v1/framework/notice');
            const rdata = response.data;
            if (rdata.status === 0) {
                const list = (rdata.data || []).map((item: any) => item.content);
                context.commit('setNotice', list);
            }
            return rdata;
        },
        /**
         * 获取上传配置
         */
        async getUploadConfig(context, { type, ext }) {
            const response = await Vue.axios.get('/api/v1/framework/upload_config', {
                params: {
                    type,
                    ext,
                    t: Math.random(),
                },
            });
            const rdata = response.data;
            return rdata;
        },
        async uploadToAliyun(context, { file, uploadConfig }: { file: File; uploadConfig: Framework.UploadConfig }) {
            const data = objectToFormData({
                key: uploadConfig.key,
                OSSAccessKeyId: uploadConfig.access_key_id,
                // 'x-oss-security-token': uploadConfig.sts_token,
                policy: uploadConfig.policy,
                Signature: uploadConfig.signature,
                file,
            });
            let ret = false;
            let end = 0;
            const response = await Vue.axios.post(uploadConfig.host, data, {
                // withCredentials: true,
                timeout: 0,
                headers: {
                    Origin: 'http://hundred-test.xorout.com',
                },
                // onUploadProgress(event) {
                //     commit('setRequestProgress', Math.floor((event.loaded / event.total) * 100), {
                //         root: true,
                //     });
                // },
            }).then((response) => {
                ret = true;
                end = Date.now();
                return {
                    status: 200,
                    data: {
                        status: 0,
                        message: 'OK',
                        data: {
                            key: uploadConfig.key,
                            url: uploadConfig.url,
                        },
                    },
                };
            }).catch((err) => {
                ret = true;
                end = Date.now();
                return {
                    // 报错
                    status: 500,
                    data: {
                        status: -1,
                        message: '啊哦，上传出现了点小问题',
                        data: {
                            url: '',
                            key: '',
                        },
                    },
                };
            });
            return response.data;
        },
        async configAndUploadToAliyun(context, { file, type }: { file: File; type: string }) {
            const name = file.name;
            const pos = name.lastIndexOf('.');
            const ext = pos >= 0 ? name.substr(pos + 1) : 'ukn';
            const rdata: ResponseData<Framework.UploadConfig> = await context.dispatch('getUploadConfig', {
                type,
                ext,
            });
            if (rdata.status !== 0) {
                Toast(rdata.message);
                return;
            }

            const uploadRdata: ResponseData<ImageInfo> = await context.dispatch('uploadToAliyun', {
                file,
                uploadConfig: rdata.data,
            });
            if (rdata.status !== 0) {
                Toast(rdata.message);
                return;
            }

            return uploadRdata;
        },
    },
};

export default m;
